import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environmentCAS';

export interface CasTransaction {
  nb_enfant_assure?: number;
  deplacement_professionnel?: boolean;
  port_charge?: boolean;
  travaille_en_hauteur?: boolean;
  id: number;
  reference?: string;
  project_id: string;
  contact_id: number;
  user_id: number;

  // Pipeline / suivi
  phase_transaction?: string;
  date_creation_transaction?: string;
  date_effective?: string;
  date_contact?: string;
  date_envoi_devis?: string;
  date_derniere_demande_information?: string;
  revenu?: number;
  commentaire?: string;
  resultat_appel?: string;
  status?: string;
  date_traitement?: string;

  // Devis / contrat
  nbre_devis_envoyes?: number;
  devis_envoye?: boolean;
  nom_assureurs?: string;
  numero_devis?: string;
  numero_contrat?: string;
  statut_contrat?: string;
  nb_contrat?: number;
  motif_refus?: string;
  assureur?: string;
  produit?: string;
  nom_produit?: string;
  cout_mensuel_assurance?: number;
  cout_total_assurance?: number;
  precedent_assureur?: string;

  // Santé Entreprise
  nombre_salaries?: number;
  budget_pmss?: number;
  convention_collective?: string;
  college?: string;

  // Métadonnées
  origine?: string;
  projet_source_id?: string;

  // Contact lié (embarqué pour l'affichage liste)
  contact?: {
    id: number;
    reference?: string;
    civilite?: string;
    nom?: string;
    prenom?: string;
    mobile?: string;
    email?: string;
    ville?: string;
    statut_du_lead?: string;
  } | any;
}

export interface TransactionFilters {
  contact_id?: number;
  phase_transaction?: string;
}

@Injectable({ providedIn: 'root' })
export class CasTransactionService {
  private apiUrl = `${environment.apiUrl}/api/cas/transactions`;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('access_token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
  }

  list(limit = 100, offset = 0, filters?: TransactionFilters): Observable<CasTransaction[]> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());
    if (filters?.contact_id != null) {
      params = params.set('contact_id', filters.contact_id.toString());
    }
    if (filters?.phase_transaction) {
      params = params.set('phase_transaction', filters.phase_transaction);
    }
    return this.http.get<CasTransaction[]>(this.apiUrl, {
      params,
      headers: this.getAuthHeaders(),
    });
  }

  count(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.apiUrl}/count`, {
      headers: this.getAuthHeaders(),
    });
  }

  /** Payload du formulaire CAC reconstruit depuis Contact+Transaction (sans project_history). */
  getFormPayload(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}/form`, {
      headers: this.getAuthHeaders(),
    });
  }

  get(id: number): Observable<CasTransaction> {
    return this.http.get<CasTransaction>(`${this.apiUrl}/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  create(payload: Partial<CasTransaction>): Observable<CasTransaction> {
    return this.http.post<CasTransaction>(this.apiUrl, payload, {
      headers: this.getAuthHeaders(),
    });
  }

  update(id: number, payload: Partial<CasTransaction>): Observable<CasTransaction> {
    return this.http.patch<CasTransaction>(`${this.apiUrl}/${id}`, payload, {
      headers: this.getAuthHeaders(),
    });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }
}
